import { AuthGuard } from '@onesource/components';
import { createFileRoute } from '@tanstack/react-router';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { PaymentPlanDetailPage } from 'src/pages/billing/payment-plan-detail';

export const Route = createFileRoute('/payment-plans/$paymentPlanId')({
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <PaymentPlanDetailPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
